import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Tabs from "../Tabs/Tabs";
import FormBuilderWorkspace from "./FormBuilderWorkspace";
import FormBuilderErrors from "./FormBuilderErrors";

export default class FormBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_tab: "general",
      answers: [],
      count:
        this.props.form_fields && this.props.form_fields.length
          ? this.props.form_fields.length
          : 0,
      order: [],
      title: this.props.title ? this.props.title : "",
      description: this.props.description ? this.props.description : "",
      form_fields: this.props.form_fields ? this.props.form_fields : [],
      all_forms:
        this.props.all_forms && this.props.all_forms.length
          ? this.props.all_forms
          : [],
      customer_form: this.props.customer_form || false,
      all_form_fields: this.props.all_form_fields || {},
      form_type: this.props.form_type || "please_select_one",
      order_form: this.props.order_form || false,
      survey_form: this.props.survey_form || false,
      document_form: this.props.document_form || false,
      step: "start",
      file_upload_group: [{ file_uploads: [] }],
      customer_image_form_field_id: "",
      currentStepId: "",
      logo_image_url: this.props.logo_image_url
        ? this.props.logo_image_url
        : null,
      status: this.props.status ? this.props.status : "disabled",
      property_name: this.props.property_name ? this.props.property_name : "",
      property_address: this.props.property_address
        ? this.props.property_address
        : "",
    };

    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeTextField = this.onChangeTextField.bind(this);
    this.onChangeFormFields = this.onChangeFormFields.bind(this);
    this.onChangeOrder = this.onChangeOrder.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeCustomerForm = this.onChangeCustomerForm.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.onChangeFormFieldsPreview = this.onChangeFormFieldsPreview.bind(this);
    this.onChangeSelectedRating = this.onChangeSelectedRating.bind(this);
    this.onChangeSelectedEmoji = this.onChangeSelectedEmoji.bind(this);
    this.onChangeFileUploadGroup = this.onChangeFileUploadGroup.bind(this);
    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.handlePlaceSelect = this.handlePlaceSelect.bind(this);
    this.onChangeStep = this.onChangeStep.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);

    this.onChangeFormFieldsDocumentPreview =
      this.onChangeFormFieldsDocumentPreview.bind(this);
  }

  /** Life Cycle Methods **/

  async componentDidMount() {
    this.autocomplete = await new google.maps.places.Autocomplete(
      document.getElementById("autocomplete"),
      { types: ["address"] }
    );
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
  }

  componentDidUpdate(nextProps, nextState) {
    if (this.autocomplete) {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        { types: ["address"] }
      );
      this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
    }

    const required_field_ids = [];
    const required_fields = this.props.form_fields.filter(
      (field) => field.required == true
    );
    required_fields.map((field) => {
      required_field_ids.push(field.id);
    });
    var step = "";

    if (this.state.answers.length == required_fields.length) {
      step = "submit";
    }

    if (
      this.state.answers.length != required_fields.length &&
      this.state.answers.length > 0
    ) {
      step = "continue";
    }

    if (this.state.answers.length < 1) {
      step = "start";
    }

    if (step != this.state.step) {
      this.setState({ step: step });
    }

    if (step == "continue" && step != this.state.step) {
      this.setState({ started: new Date() });
    }

    if (step == "submit" && step != this.state.step) {
      this.setState({ ended: new Date() });
    }
  }

  /** Render Functions **/

  render() {
    console.log("form_builder_props", this.state);
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: this.onSubmit,
      },
    ];

    return (
      <div className="AdditionalCustomerFieldBuilder" ref="form">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons buttons={buttons} />
          <FormBuilderWorkspace
            {...this.state}
            onChangeFormFields={this.onChangeFormFields}
            onChangeOrder={this.onChangeOrder}
            onChangeTextField={this.onChangeTextField}
            onChangeCustomerForm={this.onChangeCustomerForm}
            onChangeType={this.onChangeType}
            onChangeFormFieldsPreview={this.onChangeFormFieldsPreview}
            onChangeSelectedRating={this.onChangeSelectedRating}
            onChangeSelectedEmoji={this.onChangeSelectedEmoji}
            onChangeFileUploadGroup={this.onChangeFileUploadGroup}
            onChangeAddress={this.onChangeAddress}
            handlePlaceSelect={this.handlePlaceSelect}
            onChangeStep={this.onChangeStep}
            onChangeFormFieldsDocumentPreview={
              this.onChangeFormFieldsDocumentPreview
            }
            onChangeStatus={this.onChangeStatus}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  tabs() {
    if (
      this.props.form_type === "customer" ||
      this.props.form_type === "survey"
    ) {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: FormBuilderErrors.generalErrors(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("form_fields"),
          targetName: "form_fields",
          classes: this.state.active_tab === "form_fields" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: FormBuilderErrors.formFieldErrors(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("preview"),
          targetName: "preview",
          classes: this.state.active_tab === "preview" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
    } else {
      return [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: FormBuilderErrors.generalErrors(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("form_fields"),
          targetName: "form_fields",
          classes: this.state.active_tab === "form_fields" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
          tabErrorCount: FormBuilderErrors.formFieldErrors(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("preview"),
          targetName: "document_preview",
          classes:
            this.state.active_tab === "document_preview" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
    }
  }

  /** Change Handlers **/

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeOrder(idsInOrder) {
    this.setState({ order: idsInOrder });
  }

  onChangeTextField(event) {
    if (event && event.target) {
      var state = $.extend(true, {}, this.state);
      state[event.target.name] = event.target.value;
      this.setState(state);
    }
  }

  onChangeFormFields(event) {
    if (event && event.target) {
      this.setState({ form_fields: event.target.value });
    }
  }
  onChangeCustomerForm(event) {
    this.setState({ customer_form: event.target.checked });
  }

  onChangeType(event) {
    this.setState({ form_type: event.target.value });
  }

  onChangeFormFieldsPreview(e) {
    var answers = this.state.answers;

    this.state.form_fields.map((field) => {
      if (field.id === e.target.id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === e.target.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === e.target.id) {
              if (e.target.name == "number") {
                answer.number_answer = e.target.value;
              } else if (e.target.name == "date") {
                answer.date_answer = e.target.value;
              } else {
                answer.answer = e.target.value;
              }
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          if (e.target.name == "number") {
            var new_answer = {
              form_field_id: e.target.id,
              number_answer: e.target.value,
            };
          } else if (e.target.name == "date") {
            var new_answer = {
              form_field_id: e.target.id,
              date_answer: e.target.value,
            };
          } else {
            var new_answer = {
              form_field_id: e.target.id,
              answer: e.target.value,
            };
          }

          answers.push(new_answer);
        }
      }
    });

    this.setState({ answers: answers });
  }

  onChangeFormFieldsDocumentPreview(e) {
    var answers = this.state.answers;

    this.props.form_fields.map((field) => {
      if (field.id === e.target.id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === e.target.id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === e.target.id) {
              if (e.target.name == "display_only") {
                answer.display_only_answer = !answer.display_only_answer;
              } else {
                answer.answer = e.target.value;
                if (e.target.value == "") {
                  answers.splice(answers.indexOf(answer), 1);
                }
              }
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          if (e.target.name == "display_only") {
            var new_answer = {
              form_field_id: e.target.id,
              display_only_answer: true,
            };
          } else {
            var new_answer = {
              form_field_id: e.target.id,
              answer: e.target.value,
            };
          }
          answers.push(new_answer);
        }
      }
    });

    this.setState({ answers: answers });
  }

  onChangeSelectedEmoji(rating) {
    this.setState({
      selected_e: !this.state.selected_e,
      selected_emoji: rating,
    });
  }

  onChangeSelectedRating(rating) {
    this.setState({
      selected_r: !this.state.selected_r,
      selected_rating: rating,
    });
  }

  handlePlaceSelect() {
    var addressObject = this.autocomplete.getPlace();
    var address = addressObject.address_components;
    var answers = this.state.answers;
    var form_field_address_field_id = this.state.form_field_address_field_id;
    for (let i = 0; i < address.length; i++) {
      for (let j = 0; j < address[i].types.length; j++) {
        if (address[i].types[j] === "street_number") {
          var street_number = address[i].long_name;
        }
        if (address[i].types[j] === "route") {
          var route = address[i].long_name;
        }
        if (address[i].types[j] === "locality") {
          var city = address[i].long_name;
        }
        if (address[i].types[j] === "administrative_area_level_1") {
          var state_province = address[i].long_name;
        }
        if (address[i].types[j] === "postal_code") {
          var postal_code = address[i].long_name;
        }
        if (address[i].types[j] === "country") {
          var country = address[i].long_name;
        }
      }
    }
    var newAddressObject = {
      address_1: street_number ? `${street_number} ${route}` : route,
      formatted_address: addressObject.formatted_address,
      city: city,
      state: state_province,
      country: country,
      postal_code: postal_code,
      form_field_id: form_field_address_field_id,
    };

    this.state.form_fields.map((field) => {
      if (field.id === newAddressObject.form_field_id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === newAddressObject.form_field_id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer, idx) => {
            if (answer.form_field_id === newAddressObject.form_field_id) {
              answers[idx] = newAddressObject;
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          var new_answer = newAddressObject;
          answers.push(new_answer);
        }
      }
    });
    this.setState({
      answers: answers,
    });
  }

  onChangeAddress(form_field_id, e) {
    var answers = this.state.answers;
    this.state.form_fields.map((field) => {
      if (field.id === form_field_id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field_id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field_id) {
              answer.formatted_address = e.target.value;
            }
          });
        } else {
          if (!answers) {
            answers = [];
          }
          if (e.target.name == "answers[formatted_address]") {
            var new_answer = {
              form_field_id: form_field_id,
              formatted_address: e.target.value,
            };
          }
          answers.push(new_answer);
        }
      }
    });
    this.setState({
      answers: answers,
      form_field_address_field_id: form_field_id,
    });
  }

  onChangeFileUploadGroup(file_upload_group, form_field_id) {
    var answers = this.state.answers;
    this.props.form_fields.map((field) => {
      if (field.id === form_field_id) {
        var found = false;
        if (answers) {
          for (var i = 0, ilen = answers.length; i < ilen; i++) {
            if (answers[i].form_field_id === form_field_id) {
              found = true;
              break;
            }
          }
        }
        if (found) {
          answers.map((answer) => {
            if (answer.form_field_id === form_field_id) {
              answer.image_answer = [file_upload_group];
            }
          });
        } else {
          if (!answers) {
            answers = [];
          } else {
            var new_answer = {
              image_answer: [file_upload_group],
              form_field_id: form_field_id,
            };
          }
          answers.push(new_answer);
        }
      } else if (form_field_id == null) {
        answers = answers.filter((answer) => !answer.image_answer);
      }
    });
    this.setState({ answers: answers });
  }

  onChangeStep = (step) => {
    const required_field_ids = [];
    const required_fields = this.props.form_fields.filter(
      (field) => field.required == true
    );
    required_fields.map((field) => {
      required_field_ids.push(field.id);
    });
    const answersFilledArray = [];
    this.state.answers.map((answer) => {
      if (answer.answer || answer.display_only_answer || answer.image_answer) {
        answersFilledArray.push(answer.form_field_id);
      }
    });
    if (step == "start") {
      window.document
        .getElementById(required_field_ids[0])
        .scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      this.setState({
        step: "continue",
        started: new Date(),
        currentStepId: required_field_ids[0],
      });
    }
    if (step == "continue") {
      if (answersFilledArray.length < required_field_ids.length) {
        required_field_ids.forEach((field, idx) => {
          if (answersFilledArray.includes(field)) {
            if (idx < required_field_ids.length - 1) {
              window.document
                .getElementById(required_field_ids[idx + 1])
                .scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              this.setState({
                step: "continue",
                currentStepId: required_field_ids[idx + 1],
              });
              return;
            } else if (idx == required_field_ids.length - 1) {
              const notAnsweredFields = required_field_ids.filter(
                (field) => !answersFilledArray.includes(field)
              );
              window.document
                .getElementById(notAnsweredFields[0])
                .scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              this.setState({
                step: "continue",
                currentStepId: notAnsweredFields[0],
              });
              return;
            }
          }
        });
      } else if (answersFilledArray.length == required_field_ids.length) {
        this.setState({
          step: "submit",
          ended: new Date(),
        });
      }
    }
  };

  onChangeStatus(event) {
    if (event && event.target) {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  }

  // /** AJAX Calls **/

  onSubmit() {
    var self = this;
    self.setState({ loading: true });
    setTimeout(function () {
      $.ajax({
        type: self.props.is_new ? "POST" : "PATCH",
        url: self.props.is_new ? self.props.create_path : self.props.save_path,
        data: {
          title: self.state.title,
          description: self.state.description,
          customer_form: self.state.customer_form || false,
          form_fields:
            self.state.form_fields.length > 0
              ? JSON.stringify(self.state.form_fields)
              : [],
          order: self.state.order.length > 0 ? self.state.order : [],
          form_type: self.state.form_type,
          status: self.state.status,
        },
      })
        .done(function (data) {
          if (data && data.errors && data.errors.length) {
            self.setState({
              errors: data.errors,
              loading: false,
            });
          } else {
            if (parent && parent.refresh_data) {
              if (self.props.is_new == true) {
                parent.refresh_data(I18n.t("form_created_successfully"));
              } else {
                parent.refresh_data(I18n.t("form_saved_successfully"));
              }
            }
            if (parent && parent.hide_modal) {
              parent.hide_modal();
            }
          }
        })
        .catch((data) => {
          if (data && data.responseJSON) {
            self.setState({ errors: data.responseJSON, loading: false });
            $(".modal-body").scrollTop(0);
          }
        });
    }, 1000);
  }
}
